import { render } from "./MyApprove.vue?vue&type=template&id=6d224bbf&scoped=true"
import script from "./MyApprove.vue?vue&type=script&lang=js"
export * from "./MyApprove.vue?vue&type=script&lang=js"

import "./MyApprove.vue?vue&type=style&index=0&id=6d224bbf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d224bbf"]])

export default __exports__